module.exports = __webpack_public_path__ + "static/1-8a96cdee16c96267f154cab6570f3423.jpg";